module.exports = __webpack_public_path__ + "static/media/align-justify.1b87f9a0.svg";